<template>
  <hooper class="user-sldr" :infiniteScroll="true" :itemsToShow="4" :centerMode="true">
    <slide
      v-for="(image,index) in images"
      :key="index"
      :style="'background-image: url('+image.url['original']+');'"
    >
      <p>{{image.title}}</p>
    </slide>
  </hooper>
</template>

<script>
import { Hooper, Slide } from "hooper";
import "hooper/dist/hooper.css";

export default {
  name: "slider-profile",
  components: {
    Hooper,
    Slide
  },
  props: {
    images: {
      type: [Array, Object],
      required: true
    }
  }
};
</script>
